import { BasisAdresse, TierartEnum, ZusatzoptionItem } from '@ps20-frontend/frontend-models';
import { Person, Produktlinienname } from '@ps20/bff-models';
import { AngebotsId } from './angebotsId';

export interface SelectedZusatzoption {
  id: string;
  fachschluessel: string;
  isInclusive: boolean;
}

export function getSelectedZusatzoptionen(
  zusatzoptionen: ZusatzoptionItem[],
): SelectedZusatzoption[] {
  return zusatzoptionen
    .filter(zusatzoption => zusatzoption.isSelected)
    .map(selectedZusatzoption => {
      return {
        id: selectedZusatzoption.id,
        fachschluessel: selectedZusatzoption.fachschluessel,
        isInclusive: selectedZusatzoption.isInclusive,
      };
    });
}

export interface DataForDashboard extends AngebotsId {
  kurztext: string;
  ausgewaehlteLinie: Produktlinienname;
  versichertesRisiko: string;
  tierSubline?: string;
  versichertePerson?: Person;
  versicherterRisikoort?: BasisAdresse;
  vertragslaufzeit: number;
  selectZusatzoptionen: SelectedZusatzoption[];
  tierart?: TierartEnum;
  beginn?: string;
  hasVorschaeden?: boolean;
  nebengebaeudeUeber200?: boolean;
  extremwetterRisk?: boolean;
  coverageType?: string;
  nebengebaeudeQM?: number;
  /**
   * Set by the Tiergruppe (TGV) for every offer of its group but the last one. The shop then only
   * updates beginn and ablauf of the offer; the sofortschutz and zaehlstuecke requests and the
   * Shop-Tarifierung run once, with the take-over of the last offer, for the whole Warenkorb.
   */
  deferTarifierung?: boolean;
}

export interface DataForDashboardAfterLoadAzam extends AngebotsId {
  versichertesRisiko?: string;
  versicherterRisikoort?: BasisAdresse;
  tierart?: TierartEnum;
}

export interface Zaehlstueck extends AngebotsId {
  kurztext: string;
  rabattstufe: number;
  isZaehlstueck: boolean;
}

export enum RabattStufeLabel {
  NULL = '0 %',
  ZWEI = '5 %',
  DREI = '10 %',
  VIER = '15 %',
  FUENF = '20 %',
  LEER = '',
  Z = 'Z',
}
